export const LOAN_PURPOSE_RESIDENTIAL = 'Residential';
export const LOAN_PURPOSE_INVESTMENT = 'Investment';
export const LOAN_PURPOSE_REFINANCE = 'Refinance';
